import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlService} from '@shared/services/url.service';
import {API_ENTITY_RELATED_PARTIES} from '../../../config/urls';
import {RelatedPartyListDto} from '@dto/entities/related-party-list.dto';

@Injectable({
  providedIn: 'root'
})
export class RelatedPartyService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  getRelatedParties(clientCode: string): Observable<RelatedPartyListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_RELATED_PARTIES, clientCode);
    return this.http.get<RelatedPartyListDto>(endpointUrl);
  }
}
